import {
  ListingType,
  FullfillmentType,
} from '@boma/supplier-portal/shared/entities';

export interface IListing {
  id?: string;
  units: number;
  price: number;
  type: ListingType;
  fulfillmentType: FullfillmentType;
  maximumFulfillmentRange: number;
  active: boolean;
  productId: string;
  locationId: string;
}
